import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../assets/css/global.css";

function Profile() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/auth/session`, { withCredentials: true })
      .then((res) => {
        if (res.data.user) {
          setUser(res.data.user);
        } else {
          navigate("/?error=Sessione Utente Inesistente");
        }
      })
      .catch(() => navigate("/?error=Sessione Utente Inesistente"));
  }, [navigate]);

  return (
    <main className="profile_container">
      <div className="window">
        <div className="details-container">
          <h2>Profilo Utente</h2>
          <img src="{`${process.env.PUBLIC_URL}/" alt="Foto Utente" />
          <h3 id="profile-name">Mario Rossi</h3>
          <p><strong>Email:</strong> mario.rossi@example.com</p>
          <p><strong>Telefono:</strong> +39 123 456 789</p>
          <p><strong>Indirizzo:</strong> Via Roma 1, Roma</p>
          <p><strong>Patente:</strong> B</p>
          <p><strong>Documento:</strong> ID12345</p>
          <p><strong>Località:</strong> Roma</p>
          <p><strong>Età:</strong> 30</p>
          <p><strong>Data di Nascita:</strong> 01/01/1993</p>
        </div>
      </div>

      <div className="window">
        <div className="details-container">
          <h2>Impostazioni Account</h2>
          <form id="settings-form">
            <div className="input_group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" value="mario.rossi@example.com" onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="input_group">
              <label htmlFor="password">Cambia Password</label>
              <input type="password" id="password" name="password" placeholder="Nuova Password" />
            </div>
            <div className="input_group">
              <label htmlFor="phone">Telefono</label>
              <input type="tel" id="phone" name="phone" value="+39 123 456 789" onChange={(e) => setTelephone(e.target.value)} />
            </div>
            <button type="submit">Salva Modifiche</button>
          </form>
        </div>
      </div>
    </main>
  );
}

export default Profile;